import React, {useEffect, useState} from "react";
import {CustomBackdrop, StyledContainer} from "../utils/customStyles";
import {getQueryParams, handleHttpResponse} from "../utils/http-helpers";
import {ApiUrl} from "../utils/portal-urls";
import PublishedSearchPanel from "./PublishedSearchPanel";
import PublishedAsList from "./PublishedAsList";
import ShowSnackbar from "../utils/ShowSnackbar";
import {Alert, Pagination} from "@mui/material";

export default function PublishedHome() {

    const getParameter = getQueryParams();

    const [loading, setLoading] = useState(false);
    const [refresh,setRefresh] = useState(new Date().getTime());
    const [publishedPage, setPublishedPage] = useState(getParameter.page ? parseInt(getParameter.page) : 0);
    const [publishedResult, setPublishedResult] = useState(null);
    const [query, setQuery] = useState("");
    const [queryCount, setQueryCount] = useState(0);
    const [currentViewingQuery, setCurrentViewingQuery] = useState(null);
    const [snackbarMsg, setSnackbarMsg] = useState({open: false, msg: '', msgLv: ''});

    useEffect(() => {
        console.log("page changed or refresh, useEffect fetch: ", query, publishedPage);
        if (query !== currentViewingQuery && queryCount > 0 && publishedPage > 0) {
            setPublishedPage(0);
        } else {
            fetchPublishedPage(query, publishedPage);
        }
    }, [query, publishedPage, refresh])

    const fetchPublishedPage = async (query, page) => {
        setLoading(true);
        const url = ApiUrl.Published.query.getPath(query, page);
        console.log("GET published from: " + url);
        try {
            const res = await fetch(url)
            const data = await handleHttpResponse(res)
            setPublishedResult(data);
            setCurrentViewingQuery(query);
        } catch (err) {
            console.error("Failed to get Published page\n" + err);
            setSnackbarMsg({open: true, msg: 'Failed to get published records', msgLv: 'error'});
        } finally {
            setLoading(false);
        }
    }

    return (
        <StyledContainer maxWidth='xl'>
            <h3 className='title'>Publications</h3>
            <PublishedSearchPanel
                onRefresh={r => setRefresh(r)}
                onQueryStringChanged={q => setQuery(q)}
                setPage={p => setPublishedPage(p)}
            />
            <hr/>
            <div>
                {publishedResult &&
                    <Alert severity='info' icon={false}>
                        Found {publishedResult.totalElements} record(s). &nbsp;
                        {publishedResult.totalPages > 1 && `Showing page ${publishedResult.pageable.pageNumber + 1} (${publishedResult.pageable.offset + 1} ... ${publishedResult.pageable.offset + publishedResult.pageable.pageSize})`}
                    </Alert>}
                {publishedResult?.content && publishedResult.content.length > 0 &&
                    <div>
                        <PublishedAsList
                            publishedResult={publishedResult.content}
                            setSnackbarMsg={(c) => setSnackbarMsg(c)}
                        />
                        <br/>
                        {publishedResult.totalPages >= 1 &&
                            <Pagination page={publishedPage + 1} count={publishedResult.totalPages} variant="outlined" color="primary" onChange={(e, newPage) => setPublishedPage(newPage - 1)}/>}
                    </div>
                }
            </div>
            <ShowSnackbar open={snackbarMsg.open} close={(c) => setSnackbarMsg(c)} msg={snackbarMsg} />
            <CustomBackdrop open={loading} />
        </StyledContainer>
    )
}
